<template>
  <div class="h-screen w-screen overflow-hidden bg-cover bg-center">
    <div class="h-screen w-screen overflow-auto bg-center bg-no-repeat bg-cover">
      <div class="h-full mx-auto md:mx-0 font-montserrat">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import ALink from "../../ClientPortal/UI/ALink.vue"

export default {
  name: "AuthApp",

  components: {
    ALink,
  },

  beforeMount() {
  },
}
</script>
